import React from "react";
import { MetricKpi } from "../../MetricCards";
import panelStyles from "../../styles/Panel.module.css";
import analyticsStyles from "../../styles/Analytics.module.css";
import {
  formatMoney,
  formatNumber,
  formatPercent
} from "../../utils/formatters";

export function AnalyticsSummaryBlock({ analyticsData, conclusions, dashboard }) {
  const cohortDay = analyticsData?.periods?.day;
  const rollingDay = analyticsData?.rollingPeriods?.day;
  const moneyDay = analyticsData?.money?.day;
  const subs = analyticsData?.money?.activeSubscriptions;
  const paidActive = subs?.paid ?? analyticsData?.money?.activePaid ?? 0;
  const giftedActive = subs?.gifted ?? 0;
  const legacyActive = subs?.legacy ?? 0;

  const parentRevenue = moneyDay?.parentPayment?.revenue ?? 0;
  const parentShare =
    moneyDay?.revenue > 0
      ? formatPercent((parentRevenue / moneyDay.revenue) * 100)
      : formatPercent(null);

  return (
    <>
      <div className={analyticsStyles.block}>
        <h3>Ключевые показатели</h3>
        <div className={analyticsStyles.kpis}>
          <MetricKpi
            title="Активация новых (когорта дня)"
            value={`${formatNumber(cohortDay?.activation?.activated)} (${formatPercent(cohortDay?.activation?.rate)})`}
            hint="Пользователи, зарегистрированные сегодня, которые сделали 1+ запрос."
          />
          <MetricKpi
            title="Активные за 24ч (все пользователи)"
            value={formatNumber(rollingDay?.activation?.activatedAll ?? rollingDay?.activation?.activated)}
            hint="Скользящее окно: новые + возвращающиеся пользователи с 1+ запросом за последние 24 часа."
          />
          <MetricKpi
            title="Выручка за 24ч"
            value={formatMoney(moneyDay?.revenue)}
            hint="Сумма всех purchase (amount) за последние 24 часа."
          />
          <MetricKpi
            title="Оплата родителями (доля)"
            value={`${formatMoney(parentRevenue)} (${parentShare})`}
            hint="purchase с payment_source=parent_payment. Учитывается в выручке."
          />
        </div>

        <div className={analyticsStyles.kpis}>
          <MetricKpi
            title="Подписки: платные активные"
            value={formatNumber(paidActive)}
            hint="Подтверждённые платные подписки (без legacy)."
          />
          <MetricKpi
            title="Подписки: подарочные"
            value={formatNumber(giftedActive)}
            hint="Бесплатные выдачи (ручные, рулетка, промо)."
          />
          <MetricKpi
            title="Подписки: legacy (не KPI)"
            value={formatNumber(legacyActive)}
            hint="unknown_legacy / старые источники. Исключено из KPI, LTV и конверсии."
          />
        </div>
      </div>

      <div className={analyticsStyles.block}>
        <h3>Аналитические выводы</h3>
        {analyticsData.executiveSummary?.length ? (
          <ul className={analyticsStyles.list}>
            {analyticsData.executiveSummary.map((item, index) => (
              <li key={`summary-${index}`}>{item}</li>
            ))}
          </ul>
        ) : (
          <div className={panelStyles.note}>Выводы появятся после накопления данных.</div>
        )}
          <div className={analyticsStyles.kpis}>
          <MetricKpi title="Главное узкое место" value={conclusions.bottleneck?.label || "—"} hint="Максимальная потеря между этапами воронки." />
          <MetricKpi title="Метрика роста" value={conclusions.growthMetric || "—"} hint="Самая слабая метрика из ключевых этапов воронки." />
          <MetricKpi title="Фокус улучшений" value={conclusions.focus || "—"} hint="Приоритетная зона роста по текущим данным." />
          <MetricKpi title="Прогноз до цели 300" value={conclusions.goalWeeks ? `${conclusions.goalWeeks} недель` : "—"} hint="Оценка времени до 300 платных активных подписок." />
        </div>
      </div>

      <div className={analyticsStyles.block}>
        <h3>Операционный дашборд за последние 24 часа</h3>
        <pre className={analyticsStyles.dashboard}>{dashboard.text || "Нет данных..."}</pre>
      </div>
    </>
  );
}

export default AnalyticsSummaryBlock;
